module.exports = __webpack_public_path__ + "img/IT0002230555189.2f5664f7.png";